import { Box, Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import styled from 'styled-components';
import * as CONST from '../../../constants/FieldsConst';
import { textLabels } from '../../../helpers';
import { useNotification } from '../../../helpers/Notification';
import { LoadingWidget } from '../../../widgets';
import ActionsListWidget from '../../../widgets/ActionsList';
import DeleteModalComponent from '../../../widgets/modals/DeleteModal';
import { NameComponent } from '../../usuario/usuarios/components/ListadoUsuarios';
import {
  allActividadesExtcurAction,
  deleteActividadesExtcurAction,
  setActivoActividadesExtcurAction,
} from '../ActividadesExtcurAction';
import { PARAMS_USU_ACTIVIDADES_EXTRACUR } from '../ActividadesExtcurReducer';

export const Links = styled.a`
  cursor: pointer;
  color: black;
  margin: 0px 0px;
  text-decoration: none;

  &:hover {
    color: blue;
  }
`;

const ListadoActividadesExtcur = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const actividadesExtCurStore = Redux.useSelector(
    (state) => state.actividadesExtCur,
  );
  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...actividadesExtCurStore.params,
        idUsuario: usuEntidadesStore.activo.usuario.id,
      };
      dispatch({ type: PARAMS_USU_ACTIVIDADES_EXTRACUR, payload });
      await allActividadesExtcurAction(dispatch, payload);
    };
    return fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rowsData = [];
    actividadesExtCurStore.all.forEach((el) =>
      rowsData.push({
        ...el,
        tipo: {
          nombre: el.tipo.nombre,
          deporte: el.deporte?.nombre ?? null,
        },
        estatus: el.estatus ?? '',
      }),
    );
    setRows(rowsData);
  }, [actividadesExtCurStore.all]);

  const _handleEditClick = async (id) => {
    const data = actividadesExtCurStore.all.find((el) => el.id === id);
    await setActivoActividadesExtcurAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteActividadesExtcurAction(
      { dispatch, notify },
      actividadesExtCurStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.tipo.name,
      label: CONST.tipo.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row" spacing={1} alignItems="center">
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
              >
                {value.deporte ?? value.nombre}
              </NameComponent>
              {value.deporte && (
                <Typography>
                  {'- '}
                  {value.nombre}
                </Typography>
              )}
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '70px' }}>
              <Tooltip
                describeChild
                title="Estatus del registro"
                placement="left"
              >
                <Chip
                  label={value.nombre}
                  size="small"
                  color={value.id === 1 ? 'success' : 'error'}
                />
              </Tooltip>
            </Box>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '70px' }}>
              <Stack direction="row">
                {/* <BotonComponent
                  click={async () => {
                    await setActivoActividadesExtcurAction(dispatch, value);
                  }}
                  icon
                  size="medium"
                  transparentBg
                  dashboardIcon
                  tooltip="Panel del torneo"
                /> */}
                <ActionsListWidget
                  id={tableMeta.rowData[0]}
                  onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                  onDelete={async () => {
                    const data = actividadesExtCurStore.all.find(
                      (el) => el.id === tableMeta.rowData[0],
                    );
                    await setActivoActividadesExtcurAction(dispatch, data);
                    setOpenModalDelete(true);
                  }}
                />
              </Stack>
            </Box>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={actividadesExtCurStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {actividadesExtCurStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            {actividadesExtCurStore.activo.nombre}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoActividadesExtcur;
